module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_chiba-80a5000490d1e0724cc86db76a7ae57a.png";